export default {
	STUDENT: 'Student',
	TEACHER: 'Teacher',
}
